import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// "Unlink from task" on the company card (companies/_detail) when it was opened
// from a task row's company chip.
//
// Its own controller, small on purpose: the button lives in HTML the detail
// panel fetched, so it is outside the tasks-outline controller's scope and
// nothing there can act on it — while unlinking a task from a company is no
// business of the panel's, which only knows how to show a card. Stimulus
// connects controllers in dynamically inserted markup, so a controller declared
// on the panel body is the seam that belongs to neither.
//
// After the DELETE it dispatches jane:company-unlinked so the row behind the
// panel can drop its chip without a reload, then jane:close-panel, which the
// tasks outline's detail-modal answers by closing the panel.
export default class extends Controller {
    static values = { url: String, taskId: String, companyId: String }

    async unlink(event) {
        event.preventDefault()
        if (this.element.dataset.busy === "true") return

        this.element.dataset.busy = "true"
        try {
            const response = await fetch(this.urlValue, {
                method: "DELETE",
                headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error(`unlink failed: ${response.status}`)

            window.dispatchEvent(new CustomEvent("jane:company-unlinked", {
                detail: { taskId: this.taskIdValue, companyId: this.companyIdValue }
            }))
            window.dispatchEvent(new CustomEvent("jane:close-panel"))
        } catch (error) {
            console.warn("company unlink failed", error)
            this.element.dataset.busy = "false"
        }
    }
}
